import React from "react";
import {
FaFileAlt,
FaCheck,
FaClock,
FaExclamationTriangle,
FaArrowRight,
} from "react-icons/fa";

const ProcurementStatusTracker = () => {
const steps = [
{
title: "Purchase Request",
shortTitle: "Request",
status: "completed",
date: "02 Sep 2026",
},
{
title: "Approval",
shortTitle: "Approval",
status: "completed",
date: "02 Sep 2026",
},
{
title: "Indent",
shortTitle: "Indent",
status: "completed",
date: "03 Sep 2026",
},
{
title: "Quotation",
shortTitle: "Quotation",
status: "current",
date: "In Progress",
},
{
title: "Purchase Order",
shortTitle: "PO",
status: "pending",
date: "Pending",
},
{
title: "Received",
shortTitle: "Received",
status: "pending",
date: "Pending",
},
{
title: "Stock Updated",
shortTitle: "Stock",
status: "pending",
date: "Pending",
},
];

const getStatusClass = (status) => {
switch (status) {
case "completed":
return "bg-success text-white";

      case "current":
        return "bg-primary text-white";

      case "blocked":
        return "bg-danger text-white";

      default:
        return "bg-light text-secondary border";
    }

};

const getStatusIcon = (status) => {
switch (status) {
case "completed":
return <FaCheck size={13} />;

      case "current":
        return <FaClock size={13} />;

      case "blocked":
        return <FaExclamationTriangle size={13} />;

      default:
        return <FaFileAlt size={13} />;
    }

};

return (
<div className="card border-0 shadow-sm mb-4">

      <div className="card-body p-3 p-md-4">

        {/* Header */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">

          <div>
            <h6 className="fw-bold mb-1">
              Inventory Procurement Status
            </h6>

            <small className="text-muted">
              Track the purchase process from request to stock entry
            </small>
          </div>

          <div className="mt-2 mt-md-0">
            <span className="badge bg-primary-subtle text-primary px-3 py-2">
              1 Process In Progress
            </span>
          </div>

        </div>


        {/* Progress */}
        <div className="position-relative">

          {/* Background Line */}
          <div
            className="position-absolute d-none d-md-block"
            style={{
              top: "20px",
              left: "7%",
              right: "7%",
              height: "2px",
              background: "#dee2e6",
              zIndex: 0,
            }}
          />

          {/* Completed Progress */}
          <div
            className="position-absolute d-none d-md-block bg-success"
            style={{
              top: "20px",
              left: "7%",
              width: "43%",
              height: "2px",
              zIndex: 0,
            }}
          />

          <div className="row g-0 position-relative">

            {steps.map((step, index) => (

              <div
                key={step.title}
                className="col-12 col-md text-center"
              >

                {/* Mobile connector */}
                {index !== 0 && (
                  <div
                    className={`d-md-none mx-auto ${
                      step.status === "completed"
                        ? "bg-success"
                        : "bg-light"
                    }`}
                    style={{
                      width: "2px",
                      height: "20px",
                    }}
                  />
                )}

                {/* Icon */}
                <div
                  className={`rounded-circle d-flex align-items-center justify-content-center mx-auto position-relative ${getStatusClass(
                    step.status
                  )}`}
                  style={{
                    width: "40px",
                    height: "40px",
                    zIndex: 2,
                  }}
                >
                  {getStatusIcon(step.status)}
                </div>

                {/* Text */}
                <div className="mt-2 px-1">

                  <div
                    className={`small fw-semibold ${
                      step.status === "current"
                        ? "text-primary"
                        : step.status === "completed"
                        ? "text-success"
                        : "text-secondary"
                    }`}
                  >
                    <span className="d-none d-lg-inline">
                      {step.title}
                    </span>

                    <span className="d-inline d-lg-none">
                      {step.shortTitle}
                    </span>
                  </div>

                  <small
                    className={`${
                      step.status === "current"
                        ? "text-primary"
                        : "text-muted"
                    }`}
                  >
                    {step.date}
                  </small>

                </div>

              </div>

            ))}

          </div>
        </div>


        {/* Current Status */}
        <div className="alert alert-primary border-0 mt-4 mb-0 d-flex align-items-center">

          <div className="me-3">
            <FaClock />
          </div>

          <div className="flex-grow-1">

            <div className="fw-semibold">
              Quotation process is currently in progress
            </div>

            <small>
              3 quotations received · Waiting for quotation evaluation
            </small>

          </div>

          <button className="btn btn-sm btn-primary">
            View Details
          </button>

        </div>

      </div>
    </div>

);
};

export default ProcurementStatusTracker;
